import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { S } from '../regureStyles';

// Static list of the 8 bordereaux validation rules the backend applies before
// export. Rendered as a collapsible panel below the header so users can see
// what will fail without running the validator first (per T-15.2). Kept in
// sync manually with backend/services/bordereauxValidationService.js.
const RULES = [
  { id: 'required_fields',    labelKey: 'screens.bordereaux.rules.requiredFields',    fallback: 'Required fields present (policy number, policyholder, dates, premium, LOB)' },
  { id: 'duplicate_policy',   labelKey: 'screens.bordereaux.rules.duplicatePolicy',   fallback: 'No duplicate policy numbers within the period' },
  { id: 'date_consistency',   labelKey: 'screens.bordereaux.rules.dateConsistency',   fallback: 'Effective date is before expiration date' },
  { id: 'premium_calc',       labelKey: 'screens.bordereaux.rules.premiumCalc',       fallback: 'Annual premium matches the pricing engine result (when hint provided)' },
  { id: 'carrier_match',      labelKey: 'screens.bordereaux.rules.carrierMatch',      fallback: 'Policy carrier matches the bordereaux carrier' },
  { id: 'valid_values',       labelKey: 'screens.bordereaux.rules.validValues',       fallback: 'Premium is positive, dates fall within the reporting period' },
  { id: 'assignment_present', labelKey: 'screens.bordereaux.rules.assignmentPresent', fallback: 'Policy has an assigned broker / owner' },
  { id: 'commission_rate',    labelKey: 'screens.bordereaux.rules.commissionRate',    fallback: 'Commission rate matches the broker plan (when hint provided)' },
];

const ValidationRulesPanel = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <div style={{ padding: '10px 32px', borderBottom: `1px solid ${S.borderLight}`, background: '#f8fafc' }}>
      <button
        onClick={() => setOpen(v => !v)}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 600,
          color: S.textSecondary,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
        }}
      >
        <span style={{ display: 'inline-block', transform: open ? 'rotate(90deg)' : 'rotate(0)', transition: 'transform 0.15s' }}>▶</span>
        {t('screens.bordereaux.rules.title', { defaultValue: 'Validation rules' })} ({RULES.length})
      </button>
      {open && (
        <ol style={{ margin: '10px 0 4px 22px', padding: 0, columns: 2, columnGap: 32, fontSize: 12, color: S.textSecondary, lineHeight: 1.7 }}>
          {RULES.map(r => (
            <li key={r.id} style={{ breakInside: 'avoid' }}>
              {t(r.labelKey, { defaultValue: r.fallback })}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default ValidationRulesPanel;
